import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20entertainment%20news%20scene%20with%20abstract%20warm%20red%20and%20gold%20glowing%20lights%20and%20paparazzi%20camera%20flashes%2C%20dark%20mysterious%20atmosphere%20with%20soft%20bokeh%20effect%20and%20deep%20shadows%2C%20celebrity%20scandal%20breaking%20news%20mood%2C%20editorial%20photography%20style%20with%20intense%20dramatic%20lighting%2C%20golden%20hour%20meets%20midnight%20noir%20aesthetic%2C%20abstract%20broken%20spotlight%20composition%20with%20tension%20and%20suspense&width=1600&height=900&seq=hero-main-bg&orientation=landscape"
          alt="51吃瓜爆料网 - 今日吃瓜热门大瓜"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col justify-center px-4 md:px-6">
        <div className="max-w-3xl">
          {/* Hot Tag */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-6">
            <i className="ri-fire-line"></i>
            <span>今日爆款</span>
          </div>

          {/* Main Headline */}
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
            某顶流男星深夜密会
            <br />
            神秘女子，酒店共处
            <br />
            8小时后凌晨分开
          </h1>

          {/* Subtitle */}
          <p className="text-background-200/80 text-sm md:text-base max-w-xl mb-8 leading-relaxed">
            据知情人士爆料，某当红顶流男星近日被拍到深夜与一位神秘女子在某五星级酒店密会，
            两人一前一后进入酒店，共处长达八小时。该男星此前一直以单身人设示人，此番爆料或将引发粉丝大地震。
          </p>

          {/* CTA Button */}
          <Link
            to="/article/1"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer group"
          >
            查看完整爆料
            <i className="ri-arrow-right-line text-base transition-transform duration-300 group-hover:translate-x-0.5"></i>
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-background-300 text-xs">向下滚动</span>
        <i className="ri-arrow-down-line text-background-300 animate-bounce"></i>
      </div>
    </section>
  );
}